// extracted by mini-css-extract-plugin
export var background = "key-figures-module--background--e2363";
export var container = "key-figures-module--container--a8aa5";
export var keyFigure = "key-figures-module--keyFigure--f3a38";
export var keyFigureDescription = "key-figures-module--keyFigureDescription--9f811";
export var keyFigureTitle = "key-figures-module--keyFigureTitle--cc513";
export var keyFiguresContainer = "key-figures-module--keyFiguresContainer--6e26f";
export var redirectLink = "key-figures-module--redirectLink--e299b";
export var title = "key-figures-module--title--5a59f";
export var titleContainer = "key-figures-module--titleContainer--ba5ed";